import { schema, t, type SchemaType } from '@colyseus/schema';

/** Persistent board state. One-shot attacks stay in messages, never here. */
export const TileState = schema(
  {
    id: t.string().default(''),
    value: t.uint32().default(0),
    col: t.uint8().default(0),
    row: t.uint8().default(0),
  },
  'TileState',
);
export type TileState = SchemaType<typeof TileState>;

export const PlayerBattleState = schema(
  {
    seat: t.uint8().default(0),
    sessionId: t.string().default(''),
    playerId: t.string().default(''),
    displayName: t.string().default(''),
    hp: t.uint8().default(100),
    score: t.uint32().default(0),
    combo: t.uint16().default(0),
    maxCombo: t.uint16().default(0),
    maxTile: t.uint32().default(0),
    moves: t.uint32().default(0),
    damageDealt: t.uint32().default(0),
    damageTaken: t.uint32().default(0),
    nextTileId: t.uint32().default(1),
    rngState: t.uint32().default(0),
    lastInputSeq: t.uint32().default(0),
    ready: t.boolean().default(false),
    rematchRequested: t.boolean().default(false),
    connected: t.boolean().default(false),
    tiles: t.array(TileState),
  },
  'PlayerBattleState',
);
export type PlayerBattleState = SchemaType<typeof PlayerBattleState>;

export const BattleRoomState = schema(
  {
    matchId: t.string().default(''),
    modeId: t.string().default('versus'),
    ruleSetId: t.string().default('2k48-battle'),
    roomCode: t.string().default(''),
    phase: t.string().default('lobby'),
    phaseSeq: t.uint32().default(0),
    seed: t.string().default(''),
    startAt: t.float64().default(0),
    resultsAt: t.float64().default(0),
    roundEndsAt: t.float64().default(0),
    /** Compatibility fields used by the generic room controller. */
    phaseStartsAt: t.float64().default(0),
    phaseEndsAt: t.float64().default(0),
    seats: t.array(PlayerBattleState),
  },
  'BattleRoomState',
);
export type BattleRoomState = SchemaType<typeof BattleRoomState>;

// Existing room code imports these generic names. They intentionally point to
// the battle-complete schema so there is one replicated-state definition.
export const SeatState = PlayerBattleState;
export type SeatState = PlayerBattleState;
export const RoomState = BattleRoomState;
export type RoomState = BattleRoomState;
